import { render, staticRenderFns } from "./layoutSection.vue?vue&type=template&id=82499d5a&scoped=true&"
import script from "./layoutSection.vue?vue&type=script&lang=js&"
export * from "./layoutSection.vue?vue&type=script&lang=js&"
import style0 from "./layoutSection.vue?vue&type=style&index=0&id=82499d5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82499d5a",
  null
  
)

export default component.exports